module.exports = __webpack_public_path__ + "media/images/pokerroom/888/step4-full-8f9ccffef30dacec572d604099639b21.jpg";